module.exports = __webpack_public_path__ + "static/img/pic_tianbao2.0de5485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_tianbao2.png
// module id = wdiy
// module chunks = 1